import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Container } from 'semantic-ui-react'

const TYPE = {
  GENERIC: 'generic',
  CLOSE: 'close',
  SUBMIT: 'submit'
}

class Popup extends React.PureComponent {
  render() {
    return (
      <Modal
        open={true}
        size={this.props.size || 'tiny'}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Header>
          {this.props.header}
        </Modal.Header>
        <Modal.Content>
          {
            this.props.isLoading
              ? <Container
                  fluid={true}
                  children="Chargement..."
                  textAlign='center'
                />
              : this.props.body
          }
        </Modal.Content>
        <Modal.Actions>
          {_.map(this.props.footer, (button) => (
            <Button
              key={button.title}
              content={button.title}
              color={button.color || undefined}
              icon={button.icon || undefined}
              basic={button.basic || false}
              style={
                button.align === 'left'
                  ? { float: 'left' }
                  : {}
              }
              loading={
                button.type === TYPE.SUBMIT
                &&
                this.props.isSaving
              }
              disabled={
                (
                  button.type !== TYPE.SUBMIT
                  &&
                  this.props.isSaving
                )
                ||
                this.props.isLoading
              }
              onClick={button.onClick}
            />
          ))}
        </Modal.Actions>
      </Modal>
    )
  }
}

Popup.BUTTONTYPE = TYPE

Popup.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  footer: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([ 'generic', 'close', 'submit' ]).isRequired,
      title: PropTypes.string.isRequired,
      color: PropTypes.string,
      icon: PropTypes.string,
      basic: PropTypes.bool,
      align: PropTypes.oneOf([ 'left', 'right' ]),
      onClick: PropTypes.func.isRequired
    }).isRequired
  ).isRequired,
  size: PropTypes.string,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/elements/Popup.js